module.exports = __webpack_public_path__ + "static/media/footer-home.61142718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-home.png
// module id = 1375
// module chunks = 42